import(/* webpackMode: "eager" */ "/vercel/path0/src/app/atulointelligence/page.js");
